/**
 * Map an Elevate API product to the Jetshop product shape used by GA4 formatters.
 */
import { getElevateBadges } from './helpers/getElevateBagdes';

export const generateProductStructure = elevateProduct => {
  if (!elevateProduct) return null;

  const brand =
    typeof elevateProduct.brand === 'string'
      ? elevateProduct.brand
      : elevateProduct.brand?.name || '';

  let primaryRoute;
  if (elevateProduct.link) {
    let path = elevateProduct.link;
    // if (path.includes('scorett.se/')) {
    //   path = '/' + path.split('scorett.se/')[1];
    // } else if (!path.startsWith('/')) {
    //   try {
    //     path = new URL(`https://${path.replace(/^\/+/, '')}`).pathname;
    //   } catch {
    //     path = `/${path}`;
    //   }
    // }
    primaryRoute = { path };
  }

  return {
    id: elevateProduct.key,
    articleNumber: elevateProduct.key,
    name: elevateProduct.title,
    subName: brand,
    brand: brand ? { name: brand } : undefined,
    hasVariants: elevateProduct.variants?.length > 0,
    variants: elevateProduct.variants,
    images: elevateProduct.imageInfo,
    badges: getElevateBadges(elevateProduct),
    price: { incVat: elevateProduct.sellingPrice?.min ?? 0 },
    previousPrice: { incVat: elevateProduct.listPrice?.min ?? 0 },
    ticket: elevateProduct.ticket,
    stockStatus: { buyable: elevateProduct.inStock },
    link: elevateProduct.link,
    primaryRoute,
    customFields: elevateProduct.customFields,
    canonicalCategory: elevateProduct.canonicalCategory
  };
};
